import React from 'react';
import { SpriteSvg } from 'project/sprite-svg';
import '../../scss/video-cover-image.scss';
import { AccessDeniedView } from './access-denied-view';
import { useScreenDetector } from '../../../../general/js/hooks/useScreenDetector';

const VideoCoverImage = ({
    content = {},
    videoMetadata = {},
    handleClick
}) => {
    const {
        thumbnailSrc,
        posterSrc,
        accessLevel,
        title: metadataTitle,
        description: metadataDescription
    } = videoMetadata;
    const {
        title: overwriteTitle,
        previewText: overwriteDescription,
        previewLogo, coverImageAdditionalClass
    } = content;
    const { isMobile } = useScreenDetector();

    const title = overwriteTitle || metadataTitle;
    const description = overwriteDescription || metadataDescription;
    const thumbnail = isMobile && posterSrc ? posterSrc : thumbnailSrc;

    return (
        <div
            id={'video-cover-image'}
            className={coverImageAdditionalClass ?
                `cover-image bring-front ${coverImageAdditionalClass}` :
                'cover-image bring-front'}
            aria-label="Video preview"
            tabIndex="0"
            onClick={handleClick}
        >
            {thumbnail && (
                <div className="cover-image__cover">
                    <img src={thumbnail} alt="video-thumbnail" />
                </div>
            )}
            <div className="cover-image__play-icon">
                <div className={'play-icon'}>
                    <SpriteSvg
                        iconName="play"
                        width={12}
                        height={18}
                        viewBox="0 0 8 12"
                    />
                </div>
            </div>
            <div className="cover-image__details">
                <div className="cover-image__logos">
                    <div className="cover-image__logos-sponsor">
                        <img src={previewLogo} alt="" />
                    </div>
                </div>
                <div className="cover-image__title">
                    { title && `${title}`}
                </div>
                <div className="cover-image__description">
                    { description && `${description}`}
                </div>
            </div>
            <AccessDeniedView accessLevel={accessLevel} />
            <div className="cover-image__shadow"></div>
        </div>
    );
};

export default VideoCoverImage;
